import { render } from "./CheckoutArea.vue?vue&type=template&id=02499e07"
import script from "./CheckoutArea.vue?vue&type=script&lang=js"
export * from "./CheckoutArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__